import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  notifyKlarnaMembershipViaSMS,
  notifyKlarnaMembershipViaEmail,
} from "../../Actions/Sales/klarnaActions";
import { uiNotification } from "../../services/UINotificationService";

const KlarnaMembershipConfirm = ({
  sessionId,
  sessionUrl,
  phone,
  email,
  onCancel,
}) => {
  const [isSending, setIsSending] = useState(false);

  const handleSendSMS = () => {
    if (!phone) {
      uiNotification.error("Phone number is required to send SMS");
      return;
    }
    setIsSending(true);
    notifyKlarnaMembershipViaSMS(sessionId, phone)
      .then((res) => uiNotification.success(res.data?.message || "SMS sent"))
      .catch((err) =>
        uiNotification.error(
          err.response?.data?.message || "Failed to send SMS",
        ),
      )
      .finally(() => setIsSending(false));
  };

  const handleSendEmail = () => {
    if (!email) {
      uiNotification.error("Email is required");
      return;
    }
    setIsSending(true);
    notifyKlarnaMembershipViaEmail(sessionId, email)
      .then((res) => uiNotification.success(res.data?.message || "Email sent"))
      .catch((err) =>
        uiNotification.error(
          err.response?.data?.message || "Failed to send email",
        ),
      )
      .finally(() => setIsSending(false));
  };

  const handleCopyLink = () => {
    if (!sessionUrl) return;
    navigator.clipboard.writeText(sessionUrl);
    uiNotification.success("Link copied to clipboard!", { autoClose: 2000 });
  };

  return (
    <div className="klarna-modal">
      <div className="col-sm-12 m-t-40">
        <h3
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "center",
            lineHeight: "38px",
          }}
        >
          <img
            src="/images/klarna.png"
            alt="klarna"
            style={{ height: "auto", width: 70 }}
          />{" "}
          Waiting for Payment Confirmation
        </h3>
      </div>
      <div className="col-sm-12 col-md-10 col-md-offset-1 m-t-40">
        <button
          type="button"
          onClick={handleSendSMS}
          disabled={isSending}
          className="custom-klarna-btn d-flex text-center m-b-30"
        >
          <img src="/images/klarna-black-logo.png" alt="klarna" />
          Send SMS to Patient
        </button>
        {isSending && (
          <img className="spinner-load" src="/images/loader.gif" alt="loader" />
        )}
      </div>
      <div className="col-sm-12 m-b-40 m-t-20">
        <p className="bottom-text">Having issues sending a text to {phone}?</p>
        <p className="bottom-text">
          {email && (
            <span>
              Send link via{" "}
              <button
                type="button"
                className="link-btn"
                onClick={handleSendEmail}
              >
                email
              </button>{" "}
              to {email} <span>or</span>{" "}
            </span>
          )}
          <button type="button" className="link-btn" onClick={handleCopyLink}>
            Copy link to clipboard
          </button>
        </p>
      </div>
      <div className="col-sm-12">
        <button
          type="button"
          className="new-blue-btn pull-right"
          onClick={onCancel}
        >
          Cancel Payment
        </button>
      </div>
    </div>
  );
};

KlarnaMembershipConfirm.propTypes = {
  sessionId: PropTypes.string.isRequired,
  sessionUrl: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
};

export default KlarnaMembershipConfirm;
